export default __webpack_public_path__ + "static/media/floorplan.41a2c86e.png";